<template>
  <fragment>
    <b-card :class="'main'">
        <h1>{{ $t("messages.forbidden_title") }}</h1>
        <p>{{ $t("messages.forbidden_body") }}</p>
    </b-card>

    <LoginForm v-if="!api_token" />
  </fragment>
</template>
<script>
import LoginForm from '../components/LoginForm.vue';

export default {
  components: {
    LoginForm
  },
  metaInfo() {
    return {
      title: this.$t("messages.forbidden_title")
    }
  },
  data() {
    return {
      api_token: sessionStorage.getItem('api_token') || null
    }
  }
}
</script>